import React, { useState } from "react";
import Img from "react-image";

import Modal from "@app/components/ui/modals/Modal";
import Loader from "@app/components/ui/placeholders/Loader";

const Preview = ({ src }) => {
  return (
    <div className="student-tasks-page--award__prize">
      <div className="student-tasks-page--award__prize--wrapper">
        <Img
          src={src}
          decode={false}
          loader={<Loader />}
        />
      </div>
    </div>
  )
}

const CertificatePreviewModal = ({ src, modal, onClose }) => {
  return (
    <Modal
      onClose={onClose}
      className="modal modal--cert-preview"
      ref={modal}
      closeButton={false}
    >
      <div className="preview-modal__content">
        <Preview src={src} />
        <div className="modal-content__buttons w-flex-layout w-flex-layout--columns mb-0 mt-1">
          <button
            className="btn btn--blue btn--md"
            onClick={onClose}
          >
            Close
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default CertificatePreviewModal;